import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=7e21cbe9&scoped=true"
import script from "./PricingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e21cbe9",
  null
  
)

export default component.exports